<template>
  <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
</template>

<script>
export default {
  name: 'LoadingOverlay'
}
</script>

<style scoped>
</style>
